import React from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import BasicImage from '@home/components/BasicImage';
import TipContext from '@home/components/TipContext';
import "./index.scss";
import classnames from 'classnames';
import { getImg } from '@home/_config/getImgs';
import CommonBubble from '@home/components/CommonBubble';
import FormatHtmlTextToReact from '@home/components/FormatHtmlTextToReact';

interface MetricsCardWrapTitleProps {
  icon?: string;
  titleIcon?: string;
  imgUrl?: string; // 图片地址
  tips: string;
  isJumpable?: boolean;
  // 是否开启icon的info提示（与标题hover的提示互斥）
  isIconTips?: boolean;
  title?: React.ReactNode;
  className?: string;
  hasTitleLink?:boolean;
  onClick?: () => void;
}

const MetricsCardWrapTitle: React.FC<MetricsCardWrapTitleProps> = (props) => {
  const { icon, titleIcon, imgUrl, tips, isJumpable, isIconTips, title, className, onClick } = props;
  const nativeTitle = typeof title === 'string' || typeof title === 'number'
    ? String(title)
    : undefined;

  return (
    <CommonBubble placement="top" content={ tips && !isIconTips ? <FormatHtmlTextToReact text={tips}/> : null} >
      <div className='dbd-metrics-card-wrap__title' onClick={onClick}>
        {icon && (
          <div className="dbd-metrics-card-wrap__title__icon">
            <SvgIcon type={icon} className="text-icon" />
          </div>
        )}
        {titleIcon && (
          <img className='dbd-metrics-card-wrap__title__img__icon' src={getImg(titleIcon)} />
        )}
        {imgUrl && <BasicImage src={imgUrl} className={classnames('dbd-metrics-card-wrap__title__img', className)} />}
        <div className='dbd-metrics-card-wrap__title__text' title={nativeTitle}>
          {title}
        </div>
        {isJumpable && <SvgIcon className='dbd-metrics-card-wrap__title__right-icon' type='arrow-right' />}
        {isIconTips && <TipContext tipText={tips} className={'dbd-metrics-card-wrap__title__tips-info'} />}
      </div>
    </CommonBubble>
  );
};

export default MetricsCardWrapTitle;
